// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"acac9cdc","639":"c14b3460"}[chunkId] + ".js";
};